import React, { FC, useCallback, useEffect, useState } from "react";
import "./chapterActions.scss";
import { Tabs } from "antd";
import SortableContentList from "../../../../shared/components/CourseComponents/SortableContentList";
import AddContent from "../AddContent";
import ChapterContentService from "../../../../services/CourseServices/ChapterService/chapterContent.service";
import EmptyState from "../../../../shared/components/EmptyState";
import ExcerciseService from "../../../../services/ExcerciseService/excercise.service";
import AddExercise from "../AddExercise";
import { ExerciseModal } from "../../../../models/ExerciseModal/Exercise.model";
import SortableExerciseList from "../../../../shared/components/CourseComponents/SortableExerciseList";
import ButtonComponent from "../../../../shared/components/ButtonComponent";
import { DownloadOutlined } from "@ant-design/icons";
import BulkUpload from "./BulkUpload";
import { convertJsonToXslx } from "../../../../shared/utils/xlsxConverter";
import { ExerciseXslxHeaders } from "../../../../enums/exerciseXslxHeaders";

const { TabPane } = Tabs;

interface ChapterActionsProps {
  params?: any;
  activeChapter: any;
  fetchChapterExerciseList: Function;
  fetchChapterContentsList: Function;
  exercises: any[];
  contents: any[];
}

const ChapterActions: FC<ChapterActionsProps> = (props: any) => {
  const { activeChapter, fetchChapterContentsList, fetchChapterExerciseList, params } =
    props;
  const [contents, setContents] = useState<any>([]);
  const [exercises, setExercises] = useState<any>([]);
  const [showAddContent, setShowAddContent] = useState<boolean>(false);
  const [showAddExercise, setShowAddExercise] = useState(false);
  const [tab, setTab] = useState("content");
  const [showBulkUpload, setBulkUpload] = useState<boolean>(false);

  useEffect(() => {
    setExercises(props.exercises);
    setContents(props.contents);
  }, [props]);

  useEffect(() => {
    if (activeChapter) {
      fetchChapterContentsList();
      fetchChapterExerciseList();
    }
  }, [activeChapter]);

  // const fetchChapterExerciseList = () => {
  // 	ExcerciseService.getExcerciseByFilter(
  // 		{
  // 			chaptor_id: activeChapter.id,
  // 		},
  // 		(exercises: ExerciseModal[]) => {
  // 			setExercises(exercises);
  // 		},
  // 		() => {}
  // 	);
  // };

  // const fetchChapterContentsList = () => {
  // 	let queryParam = `?chaptor_id=${activeChapter.id}`;

  // 	ChapterContentService.getChapterContentsList(
  // 		queryParam,
  // 		(chapterContents: any) => {
  // 			setContent(chapterContents);
  // 		},
  // 		() => {},
  // 		() => {}
  // 	).then();
  // };

  const handleBulkUpload = () => { };

  const handleTabChange = (key: string) => {
    setTab(key);
  };

  const handleCloseModal = useCallback(() => {
    setShowAddExercise(false);
  }, []);

  const handleAdd = () => {
    switch (tab) {
      case "exercise":
        setShowAddExercise(true);
        showAddContent && setShowAddContent(false);
        return;
      case "content":
        setShowAddContent(true);
        showAddExercise && setShowAddExercise(false);
        return;
      default:
        return;
    }
  };
  const handleDownload = () => {
    convertJsonToXslx("questions.xlsx", "Questions", [
      ExerciseXslxHeaders.EXERCISE_ID,
      ExerciseXslxHeaders.QUESTION_CONTENT,
      ExerciseXslxHeaders.QUESTION_IMAGE,
      ExerciseXslxHeaders.ONLY_FREE_TEXT,
      ExerciseXslxHeaders.OPTION1,
      ExerciseXslxHeaders.IMAGE_OPTION1,
      ExerciseXslxHeaders.OPTION2,
      ExerciseXslxHeaders.IMAGE_OPTION2,
      ExerciseXslxHeaders.OPTION3,
      ExerciseXslxHeaders.IMAGE_OPTION3,
      ExerciseXslxHeaders.OPTION4,
      ExerciseXslxHeaders.IMAGE_OPTION4,
      ExerciseXslxHeaders.CORRECT_ANSWER,
      ExerciseXslxHeaders.SOLUTION,
      ExerciseXslxHeaders.SOLUTION_IMAGE,
    ]);
  };
  return (
    <>
      <AddContent
        visible={showAddContent}
        setVisible={setShowAddContent}
        refreshList={fetchChapterContentsList}
        activeChapter={activeChapter}
      />
      <BulkUpload
        showDocUpload={true}
        params={params}
        visible={showBulkUpload}
        closeHandler={() => {
          setBulkUpload(false);
        }}
      />
      <AddExercise
        visible={showAddExercise}
        closeModalHandler={handleCloseModal}
        activeChapter={activeChapter}
        refreshList={fetchChapterExerciseList}
      />
      <div className="content__header">
        {String(activeChapter?.position).padStart(2, "0")} -{" "}
        {activeChapter?.name}
      </div>
      <div className="content__tab">
        <Tabs onChange={handleTabChange} type="card">
          <TabPane tab="Content" key="content">
            <div className="content__tab__pane">
              {contents.length !== 0 ? (
                <SortableContentList
                  list={contents}
                  setList={setContents}
                  menuText="Content"
                  refreshList={fetchChapterContentsList}
                />
              ) : (
                <EmptyState text={"No content found."} />
              )}
            </div>
          </TabPane>
          <TabPane tab="Exercise" key="exercise" className="exercise-tab">
            <div className="content__tab__pane">
              {exercises?.length ? (
                <SortableExerciseList
                  list={exercises}
                  setList={setExercises}
                  menuText="Exercise"
                  refreshList={fetchChapterExerciseList}
                />
              ) : (
                <EmptyState text={"No exercises found."} />
              )}
            </div>
            <div className="exercises__controllers">
              <ButtonComponent
                type="text"
                iconLeft={<DownloadOutlined />}
                buttonContent="Template Excel"
                onClick={handleDownload}
              />

              <ButtonComponent
                type="primary"
                onClick={() => setBulkUpload(true)}
                buttonContent="Bulk Upload"
              />
            </div>
          </TabPane>
        </Tabs>
      </div>
      <div className="content__float__add" onClick={handleAdd}>
        +
      </div>
    </>
  );
};

export default ChapterActions;
